<template>
  <div class="mb-2">
    <Button size="small" type="primary" @click="pushRouter">返回</Button>
    <template v-if="$route.name.split('-')[0] != 'CQ9'">
      <Checkbox v-model="tableShow" class="mx-1">额外栏位</Checkbox>
    </template>
    <slot></slot>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      items: {}
    }
  },
  beforeDestroy () {
    this.changeCkeck(false)
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
    tableShow: {
      get () {
        return this.lidaTableCheck
      },
      set (val) {
        this.changeCkeck(val)
      }
    },
  },
  methods: {
    ...mapActions(['changeCkeck']),
    pushRouter () {
      this.$router.go(-1,{params:this.$route.params})
    }
  }
}
</script>